import {CONFIG} from "../config/config";

const API_BASE_URL = CONFIG.serverUrl;
const env = process.env.REACT_APP_ENV;

export const generateEndpoint = (endpoint: string) => {
  if (env === 'production') {
    return `https://${endpoint}-${API_BASE_URL}`
  } else if (env === 'development') {
    return `http://127.0.0.1:5003/ptshb-b1eb0/asia-east1/${endpoint}`
  }
}

export const fetchGet = async (url: string, token: string) => {
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });

  const data = await response.json();
  return data ? data.data : null;
}

export const fetchPatch = async(url: string, token: string, payload: object) => {
  const response = await fetch(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return response.json();
}

export const fetchPost = async(url: string, token: string, payload: object) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return response.json();
}

export const fetchDelete = async(url: string, token: string, payload: object) => {
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return response.json();
}
